import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { Mid } from '@mid/sdk'
import './index.css'

import LoginWrapper from './Components/LoginWrapper'
import config from './config'
import LoadingPage from './Layout/Loading'
import App from './Layout/App'

const mid = new Mid({
  redirectUrl: `${config.redirectBaseUrl}/auth/callback`,
  logoutRedirectUrl: `${config.redirectBaseUrl}/logout`,
  loginInfo: {
    appId: config.clientId,
    oidcConfigUrl: config.oidcConfigUrl,
    authDriver: 'mid',
  },
  async landingFn(): Promise<void> {
    window.location.hash = ''
  },
})

ReactDOM.render(
  // @ts-ignore
  <LoginWrapper mid={mid} loadingNode={(props) => <LoadingPage {...props} />}>
    <BrowserRouter>
      <Switch>
        <Route path="/*" render={() => <App mid={mid} />} />
      </Switch>
    </BrowserRouter>
  </LoginWrapper>,
  document.getElementById('root'),
)
